<template>
    <ResourceInput
        label="Summary bullets"
        attribute="summaryBullets"
        type="textarea"
        help-text="One per line"
    />
</template>
